// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__HcLQx","popup__title":"errorPopup_popup__title__9oRHP","popup__img":"errorPopup_popup__img__GMlkf","popup__nextBtn":"errorPopup_popup__nextBtn__+XurT"};